export const POINT = {
  MIN_EXCHANGE: 500,
  EXCHANGE_UNIT: 100,
  DAY_MAX_EXCHANGE: 50_000,
};
